import { Industry, HomeContent } from 'src/types';

import financeCreditCardIllustration from 'src/assets/images/illustrations/finance/credit-card-illustration.png';
import onlineBankingIllustration from 'src/assets/images/illustrations/finance/online-banking-illustration.png';
import securityIllustration from 'src/assets/images/illustrations/finance/security-illustration.png';
import { ReactComponent as CompetitiveRatesIcon } from 'src/assets/images/icons/finance/competitive-rates-icon.svg';
import { ReactComponent as CreditCardIcon } from 'src/assets/images/icons/finance/credit-card-icon.svg';
import { ReactComponent as FraudPreventionIcon } from 'src/assets/images/icons/finance/fraud-prevention-icon.svg';
import { ReactComponent as OnlineBankingIcon } from 'src/assets/images/icons/finance/online-banking-icon.svg';
import financeStyles from 'src/styles/finance/home.module.css';

import sportsGamblingHeroIllustration from 'src/assets/images/illustrations/gambling/sports-gambling-hero-illustration.png';
import footballSkillsIllustration from 'src/assets/images/illustrations/gambling/football-skills-illustration.png';
import noDepositBonusesIllustration from 'src/assets/images/illustrations/gambling/no-deposit-bonuses-illustration.png';
import { ReactComponent as CasinoChipIcon } from 'src/assets/images/icons/gambling/casino-chip.svg';
import { ReactComponent as LoyaltyIcon } from 'src/assets/images/icons/gambling/loyalty-icon.svg';
import { ReactComponent as PodiumIcon } from 'src/assets/images/icons/gambling/podium-icon.svg';
import { ReactComponent as SportsBetIcon } from 'src/assets/images/icons/gambling/sports-bet-icon.svg';
import gamblingStyles from 'src/styles/gambling/home.module.css';

import insuranceCoverageIllustration from 'src/assets/images/illustrations/insurance/insurance-coverage-illustration.png';
import peaceOfMindIllustration from 'src/assets/images/illustrations/insurance/peace-of-mind-illustration.png';
import travelInsuranceIllustration from 'src/assets/images/illustrations/insurance/travel-insurance-illustration.png';
import insuranceStyles from 'src/styles/insurance/home.module.css';

import mobileHeroIllustration from 'src/assets/images/illustrations/mobile/mobile-hero-illustration.png';
import globeIllustration from 'src/assets/images/illustrations/mobile/globe-illustration.png';
import mobileSimIllustration from 'src/assets/images/illustrations/mobile/mobile-sim-illustration.png';
import { ReactComponent as GlobeIcon } from 'src/assets/images/icons/mobile/globe-icon.svg';
import { ReactComponent as MobileDeviceIcon } from 'src/assets/images/icons/mobile/mobile-device-icon.svg';
import { ReactComponent as RouterIcon } from 'src/assets/images/icons/mobile/router-icon.svg';
import { ReactComponent as SimCardIcon } from 'src/assets/images/icons/mobile/sim-card-icon.svg';
import mobileStyles from 'src/styles/mobile/home.module.css';

import clothesRackIllustration from 'src/assets/images/illustrations/retail/clothes-rack-illustration.png';
import sailorIllustration from 'src/assets/images/illustrations/retail/sailor-illustration.png';
import sunglassesIllustration from 'src/assets/images/illustrations/retail/sunglasses-illustration.png';
import retailStyles from 'src/styles/retail/home.module.css';

export const HOME_CONTENT_MAP: Record<Industry, HomeContent> = {
  Finance: {
    cssStyles: financeStyles,
    sections: [
      {
        title: 'Aurora Fortuna',
        header: 'Your future, your finances',
        body: "We make banking simple, secure, and tailored to your needs. Whether you're saving for the future, managing daily expenses, or planning your next big investment, we're here to help.",
        button: 'Apply for Credit Card',
        illustration: {
          src: financeCreditCardIllustration,
          alt: 'Credit card illustration',
        },
      },
      {
        header: 'Banking Made Easy',
        body: 'From seamless online and mobile banking to personalised financial solutions, we’re here to help you reach your financial goals.\n\n Open an account in minutes, get access to real-time insights, and enjoy the peace of mind that comes with industry-leading security. Your future starts here—let’s build it together.',
        button: 'Explore our services',
        illustration: {
          src: onlineBankingIllustration,
          alt: 'Online banking illustration',
        },
      },
      {
        header: 'Security You Can Trust',
        body: 'Your financial security is our top priority. With advanced encryption, 24/7 fraud monitoring, and instant alerts, you can bank with confidence, knowing your money and personal data are protected.',
        button: 'How we protect you',
        illustration: {
          src: securityIllustration,
          alt: 'Illustration representing secure online transactions',
        },
      },
    ],
    heroSectionOverlayPanel: [
      {
        body: 'Flexible Credit to suit you',
        icon: <CreditCardIcon />,
      },
      {
        body: 'Advanced fraud protection',
        icon: <FraudPreventionIcon />,
      },
      {
        body: 'Bank anywhere, any time',
        icon: <OnlineBankingIcon />,
      },
      {
        body: 'Competitive rates',
        icon: <CompetitiveRatesIcon />,
      },
    ],
  },
  Gambling: {
    cssStyles: gamblingStyles,
    sections: [
      {
        title: 'Welcome to Spinzalot',
        subHeader: 'Unleash the Excitement',
        body: 'Get that winning feeling at Spinzalot, your go-to destination for real money casino games and nonstop entertainment! Explore thousands of thrilling games, from online slots to blackjack and roulette. At our UK online casino, your fun comes first!',
        button: 'Open an account',
        illustration: {
          src: sportsGamblingHeroIllustration,
          alt: 'Sports gambling hero illustration',
        },
      },
      {
        header: 'SpinzBack – Get Money Back on Every Spin!',
        body: 'No matter which game you play at Spinzalot, you’ll get money back every time—win or lose. That’s right! With SpinzBack, you get more value with every spin, and the money you earn goes straight into your account. ',
        button: 'Find out more',
        illustration: {
          src: footballSkillsIllustration,
          alt: 'Football skills illustration',
        },
      },
      {
        header: 'Refer a Friend Bonus',
        body: 'Players will receive this bonus when they refer a friend and their referral deposits money.',
        button: 'Find out more',
        illustration: {
          src: noDepositBonusesIllustration,
          alt: 'No Deposit Bonuses Illustration',
        },
      },
    ],
    heroSectionOverlayPanel: [
      {
        body: 'Live Casino Games',
        icon: <CasinoChipIcon />,
      },
      {
        body: 'Loyalty & VIP Programs',
        icon: <LoyaltyIcon />,
      },
      {
        body: 'Sports Betting',
        icon: <SportsBetIcon />,
      },
      {
        body: 'Tournaments & Leaderboards',
        icon: <PodiumIcon />,
      },
    ],
  },
  Insurance: {
    cssStyles: insuranceStyles,
    sections: [
      {
        title: 'Protect What Matters Most',
        subHeader: 'Affordable Insurance, Hassle-Free',
        body: 'Unexpected events can happen anytime—make sure you’re covered. Our flexible insurance plans offer peace of mind, protecting your phone, gadgets, and more from loss, damage, or theft. Get comprehensive coverage at an affordable price and stay worry-free wherever you go.',
        button: 'Sign up for Travel insurance',
        illustration: {
          src: insuranceCoverageIllustration,
          alt: 'Insurance coverage illustration',
        },
      },
      {
        header:
          'Why Insurance Matters: Protecting Your Valuables and Peace of Mind',
        body: "Life is unpredictable, but the right insurance can keep you covered when it matters most. Whether it's safeguarding your phone, home, or travel plans, having the right protection ensures you're never caught off guard. Explore the benefits of comprehensive coverage and find the perfect plan for your needs.",
        button: 'Read more',
        illustration: {
          src: peaceOfMindIllustration,
          alt: 'Peace of mind from insurance policies illustration',
        },
      },
      {
        header: 'Travel with Confidence – Insurance That Goes Where You Go',
        body: 'Unexpected delays, lost luggage, or medical emergencies abroad? Travel worry-free with our comprehensive travel insurance. Get the protection you need for a stress-free journey, no matter where your adventures take you.',
        button: 'Find out more',
        illustration: {
          src: travelInsuranceIllustration,
          alt: 'Travel insurance illustration',
        },
      },
    ],
    heroSectionOverlayPanel: [
      { body: 'Device Protection Insurance' },
      { body: 'Travel Insurance' },
      { body: 'Home Contents Insurance' },
      { body: 'Extended Warranty Coverage' },
    ],
  },
  Mobile: {
    cssStyles: mobileStyles,
    sections: [
      {
        title: 'Upgrade Your Mobile Experience Today',
        body: 'Get the latest smartphone with flexible payment options, fast delivery, and exclusive deals. Enjoy seamless performance, stunning design, and all the features you need, right at your fingertips.',
        button: 'Sign up now',
        illustration: {
          src: mobileHeroIllustration,
          alt: 'Mobile hero illustration',
        },
      },
      {
        header: 'Not sure which SIM plan to go for?',
        body: 'Choosing the right SIM plan can feel overwhelming with so many options available. Whether you’re a light user who only needs basic data, minutes, and texts, or someone who streams, browses, and chats all day long, there’s a plan that fits your needs.',
        button: 'Get Started',
        illustration: {
          src: mobileSimIllustration,
          alt: 'Mobile SIM card illustration',
        },
      },
      {
        header: 'Stay Connected Worldwide with Our International Roaming Offer',
        body: 'Traveling abroad? Enjoy seamless coverage and stay connected wherever you go. With our special international roaming offer, you can make calls, send texts, and use data without the worry of high charges.',
        button: 'Find out more',
        illustration: {
          src: globeIllustration,
          alt: 'Globe illustration',
        },
      },
    ],
    heroSectionOverlayPanel: [
      {
        body: 'Amazing data plans',
        icon: <SimCardIcon />,
      },
      {
        body: 'Lighting fast fiber',
        icon: <RouterIcon />,
      },
      {
        body: 'Free international roaming',
        icon: <GlobeIcon />,
      },
      {
        body: 'Hassle free insurance',
        icon: <MobileDeviceIcon />,
      },
    ],
  },
  Retail: {
    cssStyles: retailStyles,
    sections: [
      {
        title: 'Summer Collection',
        body: "Embrace the warmth with Stridora's exclusive summer collection. From light, breathable fabrics to bold, vibrant designs, our summer pieces are perfect for every occasion. Step into the season with style and comfort, whether you're lounging by the pool or out on the town.",
        button: 'Become a member',
        illustration: {
          src: clothesRackIllustration,
          alt: 'Retail store with clothes rack illustration',
        },
      },
      {
        header: 'Personal Styling – Curated Just for You',
        body: 'Elevate your wardrobe with a bespoke styling experience. Our expert stylists at Stridora will help you find the perfect pieces to match your style, fit, and occasion. Whether you’re refreshing your look or curating a timeless wardrobe, we offer personalized advice tailored to you',
        button: 'Find out more',
        illustration: {
          src: sunglassesIllustration,
          alt: 'Sunglasses illustration',
        },
      },
      {
        header: 'Effortless Style for the Sunny Days Ahead',
        body: "Embrace the warmth with Stridora's exclusive summer collection. From light, breathable fabrics to bold, vibrant designs, our summer pieces are perfect for every occasion. Step into the season with style and comfort, whether you're lounging by the pool or out on the town.",
        button: 'Find out more',
        illustration: {
          src: sailorIllustration,
          alt: 'Sailor illustration',
        },
      },
    ],
    heroSectionOverlayPanel: [
      { body: 'New Arrivals' },
      { body: 'Personal Styling' },
      { body: 'Luxury Essentials' },
      { body: 'Exclusive member benefits' },
    ],
  },
};
